var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pipelines-empty-state',{attrs:{"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description},scopedSlots:_vm._u([(_vm.newPipelinePath)?{key:"actions",fn:function(){return [_c('gl-button',{attrs:{"href":_vm.newPipelinePath,"variant":"confirm"}},[_vm._v(_vm._s(_vm.s__('Pipelines|New pipeline')))])]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }